/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Amateur_3_HeadingInputs */

const en_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why This Concept Must Be Presented First in Mark's Competitive Instruction`)
};

const es_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué este concepto debe presentarse primero en la instrucción competitiva de Mark`)
};

const de_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum dieses Konzept in Marks Wettkampfunterricht zuerst vorgestellt werden muss`)
};

const zh_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么在 Mark 的竞技教学中必须首先讲这一概念`)
};

const ar_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لماذا يجب تقديم هذا المفهوم أولاً في تعليم Mark التنافسي`)
};

const fr_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi ce concept doit être présenté en premier dans l'enseignement compétitif de Mark`)
};

const vi_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vì sao khái niệm này phải được trình bày đầu tiên trong hướng dẫn cạnh tranh của Mark`)
};

const sw_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa nini dhana hii lazima itangulizwe katika mafundisho ya Mark kwa wachezaji wa mashindano`)
};

const th_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำไมต้องนำเสนอแนวคิดนี้เป็นอันดับแรกในการสอนสายแข่งขันของ Mark`)
};

const bs_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zašto ovaj koncept mora biti predstavljen prvi u Markovoj kompetitivnoj instrukciji`)
};

const ja_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜこの考え方を、Markの競技者向け指導で最初に伝えるのか`)
};

const ko_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`왜이 개념은 Mark의 경쟁 지침에서 먼저 발표해야합니다.`)
};

const pt_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que este conceito deve ser apresentado em primeiro lugar na instrução competitiva de Mark`)
};

const it_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché questo concetto deve essere presentato prima nell'istruzione competitiva di Mark`)
};

const sv_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varför detta koncept måste presenteras först i Marks konkurrensinstruktion`)
};

const nl_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom dit concept eerst moet worden gepresenteerd in Marks competitieve instructie`)
};

const da_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor dette princip kommer først i Marks konkurrenceundervisning`)
};

const nb_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor dette begrepet må presenteres først i Marks konkurranseinstruksjon`)
};

const fi_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miksi tämä käsite on esitettävä ensimmäisenä Markin kilpailuohjeessa`)
};

const pl_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dlaczego ta koncepcja musi być przedstawiona jako pierwsza w instrukcjach konkurencji Marka`)
};

const ru_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почему с этой концепции начинается турнирная подготовка у тренера Mark`)
};

const tr_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Kavram Neden Mark'ın Turnuva Eğitiminde İlk Olarak Ele Alınmalı`)
};

const hi_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस अवधारणा को Mark के प्रतिस्पर्धी निर्देश में पहले प्रस्तुत किया जाना चाहिए`)
};

const id_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa Konsep Ini Harus Diperkenalkan Pertama dalam Pengajaran Kompetitif Mark`)
};

const ms_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa Konsep Ini Mesti Diperkenalkan Dahulu dalam Pengajaran Pertandingan Mark`)
};

const cs_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proč musí být tato koncepce prezentována jako první v Markově soutěžním návodu`)
};

const el_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γιατί αυτή η έννοια πρέπει να παρουσιάζεται πρώτη στην αγωνιστική διδασκαλία του Mark`)
};

const he_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מדוע יש להציג את המושג הזה לראשונה בהוראתו התחרותית של Mark`)
};

const af_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom hierdie konsep eers in Mark se mededingende onderrig aangebied moet word`)
};

const hu_method_content_step_06_detail_amateur_3_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miért kell ezt a fogalmat elsőként bemutatni Mark versenyoktatásában`)
};

/**
* | output |
* | --- |
* | "Why This Concept Must Be Presented First in Mark's Competitive Instruction" |
*
* @param {Method_Content_Step_06_Detail_Amateur_3_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_amateur_3_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Amateur_3_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Amateur_3_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_amateur_3_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_amateur_3_heading(inputs)
	return en_method_content_step_06_detail_amateur_3_heading(inputs)
});